/* The homepage hero standfirst, with the two-click claim in it. v1.

   WHAT IT CHANGES. One paragraph, section.hero p.lead:

     from  Imagine sending a real gift with a robot-written letter without
           leaving LinkedIn. We just made that happen, ...

     to    Imagine sending a real gift with a robot-written letter in two
           clicks, without leaving LinkedIn. We just made that happen, ...

   Four words moved and two added. Everything after the first full stop is
   untouched, which is why this is a whole-string swap rather than a clever
   insertion: the old text is written out in full below, so what the page said
   before and what it says now are both readable in one place.

   WHY A SCRIPT. templates/index.liquid is 236KB, past what the Admin API will
   return or replace as text, so the paragraph cannot be edited at source
   through this route. Same reason as the moved sections, the Quick Send
   playbooks and the link corrections. When that template is next rebuilt, this
   copy belongs in it and this file can go.

   WHY THERE IS NO FLASH. The hero fades in - the paragraph starts at opacity 0
   and animates up - so a swap on DOMContentLoaded happens while it is still
   invisible. The script is also loaded without defer, so it runs as early as
   the browser will let it rather than after everything else.

   IT ONLY EVER REPLACES THE EXACT OLD SENTENCE. If index.liquid is edited and
   that first sentence changes by so much as a comma, FROM stops matching and
   this does nothing at all. That is deliberate: a fuzzy match would quietly
   overwrite whoever rewrote the hero, and a hero that silently reverts is a
   worse problem than one that fails to update. If the copy stops changing,
   check FROM against the template first.

   THE CLAIM. "In two clicks" is a product claim, not a statistic - it is the
   one number in the sentence a visitor can check against the extension in a
   single demo. If the real flow is three, this line needs to say three. */
(function () {
  var SEL = 'section.hero p.lead';

  var FROM = 'Imagine sending a real gift with a robot-written letter without leaving LinkedIn. ' +
             "We just made that happen, and it's how brands are standing out again, one personal touch at a time.";

  var TO   = 'Imagine sending a real gift with a robot-written letter in two clicks, without leaving LinkedIn. ' +
             "We just made that happen, and it's how brands are standing out again, one personal touch at a time.";

  function norm(s) {
    /* The template's own whitespace is not worth being precious about, and a
       curly apostrophe from a copy-paste should not stop this matching. */
    return (s || '')
      .replace(/[‘’]/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  var WANT = norm(FROM);
  var DONE = norm(TO);

  function swap() {
    var el = document.querySelector(SEL);
    if (!el) return false;

    var now = norm(el.textContent);
    if (now === DONE) return true;      /* already done */
    if (now !== WANT) return true;      /* someone else owns this copy now */

    el.textContent = TO;
    return true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', swap);
  else swap();
  /* One late pass: the hero is the most rewritten part of this page. */
  window.addEventListener('load', function () { setTimeout(swap, 300); });
})();
